import React, { FC } from 'react';
import styles from './entity_card_components.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';
import { Paper } from '../../components/paper/Paper';

export const EntityCardContainer: FC<{
  id?: string;
}> = ({ id = '', children }) => (
  <Paper className={styles.container} level={0} id={id}>
    {children}
  </Paper>
);

export const EntityCardHeader: FC<{
  id?: string;
}> = ({ id = '', children }) => (
  <Paper className={`${styles.container} ${styles.header}`} level={0} id={id}>
    {children}
  </Paper>
);

export const EntityCardTitle: FC = ({ children }) => (
  <div className={styles.title}>{children}</div>
);

export const EntityCardItem: FC = ({ children }) => (
  <div className={styles.item}>{children}</div>
);

export const EntityCardMaterialIcon: FC<{
  name: string;
}> = ({ name }) => <MaterialIcon name={name} className={styles.icon} />;

export const EntityCardImageIcon: FC<{
  src: string;
  alt: string;
}> = ({ src, alt }) => (
  <img className={`${styles.imageIcon} ${styles.icon}`} src={src} alt={alt} />
);
